export default ["zoom", "webflow", "typeform", "email", "referral"];
